<template>
  <b-container>
    <b-row v-if="tower.stageType == 1">
      <b-col v-if="canViewMap">
        <a
          title="Localização"
          class="card-buttons"
          @click="openMap()"
          v-b-tooltip.hover
        >
          <i class="tim-icons icon-square-pin"></i>
        </a>
      </b-col>
      <b-col v-if="canEditFilled">
        <a
          title="Editar"
          class="card-buttons"
          v-b-tooltip.hover
          @click="openModalEdit()"
        >
          <i class="tim-icons icon-pencil"></i>
        </a>
      </b-col>
      <b-col v-if="canChangeTower">
        <a
          title="Próxima etapa"
          class="card-buttons"
          v-b-tooltip.hover
          @click="openModalNextStage()"
        >
          <i class="tim-icons icon-double-right"></i>
        </a>
      </b-col>
      <b-col v-if="canCommentOnTower">
        <a
          title="Comentário"
          class="card-buttons"
          v-b-tooltip.hover
          @click="openComment()"
        >
          <i class="tim-icons icon-notes"></i>
        </a>
      </b-col>
    </b-row>

    <stage-modal-next ref="stageModalNext" :id="id" @refreshData="refreshData">
    </stage-modal-next>

    <process-filled-modal
      ref="processFilledModal"
      :filledId="id"
      @refreshData="refreshData"
    >
    </process-filled-modal>

    <workflow-map-modal
      ref="workflowMap"
      :latitude="model.lastStatusLatitude"
      :longitude="model.lastStatusLongitude"
    >
    </workflow-map-modal>

    <stage-comment-modal
      ref="stageCommentModal"
      :filledId="id"
      :stageId="stageId"
      :canComment="tower.canComment"
    >
    </stage-comment-modal>

  </b-container>
</template>
<script>
export default {
  name: "WorkflowKanbanCardActions",
  props: {
    id: Number,
    stageId: String,
    model: Object,
    tower: Object,
    permission: Object,
  },
  components: {
    'workflow-map-modal': () => import("@/components_rms/workflow/WorkflowMapModal.vue"),
    StageModalNext: () =>
      import("@/components_rms/workflow/Stage/StageModalNext.vue"),
    ProcessFilledModal: () =>
      import("@/components_rms/workflow/Process/ProcessFilledModal.vue"),
    StageCommentModal: () =>
      import("@/components_rms/workflow/Stage/StageCommentModal.vue"),
  },
  computed: {
    canEditFilled() {
      if (this.permission.canAdvancedOperate) return true;
      if (this.permission.administrador) return true;
      if (this.permission.gestor) return true;
      return false;
    },
    canViewMap() {
      if (this.permission.canAdvancedOperate) return true;
      if (this.permission.administrador) return true;
      if (this.permission.gestor) return true;
      return false;
    },
    canChangeTower() {
      if (this.permission.canSimpleOperate) return true;
      if (this.permission.canAdvancedOperate) return true;
      if (this.permission.administrador) return true;
      if (this.permission.gestor) return true;
      return false;
    },
    canCommentOnTower() {
      if (this.tower.readOnly) return false;
      return true;
    },
  },
  methods: {
    openModal() {
      this.$refs.openModal.show();
    },
    openMap() {
      this.$refs.workflowMap.openModal();
    },
    openModalEdit() {
      this.$refs.processFilledModal.show();
    },
    openModalNextStage() {
      this.$refs.stageModalNext.show();
    },
    openComment() {
      this.$refs.stageCommentModal.show();
    },
    refreshData() {
      // console.log('StageSettings -> refreshData()');
      this.$emit("refreshData");
    },
  },
};
</script>
